import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";
import { TABLE_CELL_INPUT_SX } from "./tableColumnsEditor";

export interface InteractiveTableViewComponentStyles {
  root: (fitContainer: boolean) => AppSx;
  filterBar: AppSx;
  filterField: (fitContainer: boolean) => AppSx;
  rowCountCaption: AppSx;
  tableContainer: (fitContainer: boolean) => AppSx;
  table: AppSx;
  headerCell: AppSx;
  bodyCell: AppSx;
  barFillCell: AppSx;
  emptyRowCell: AppSx;
  footerRow: AppSx;
  footerCell: AppSx;
}

export function buildInteractiveTableViewComponentStyles(
  _theme: Theme
): InteractiveTableViewComponentStyles {
  return {
    root: (fitContainer) => ({
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: fitContainer ? "100%" : undefined,
      maxHeight: fitContainer ? "100%" : 420,
    }),
    filterBar: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: 0.75,
      mb: 0.75,
      flexShrink: 0,
    },
    filterField: (fitContainer) => ({
      flex: "1 1 160px",
      minWidth: 140,
      maxWidth: fitContainer ? "100%" : 280,
    }),
    rowCountCaption: { whiteSpace: "nowrap", fontSize: "0.75rem" },
    tableContainer: (fitContainer) => ({
      flex: fitContainer ? 1 : undefined,
      overflow: "auto",
      border: 1,
      borderColor: "divider",
      borderRadius: 2,
    }),
    table: { tableLayout: "fixed", width: "100%" },
    headerCell: { fontWeight: 650, bgcolor: "background.paper", py: 0.75 },
    bodyCell: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", py: 0.75 },
    barFillCell: { overflow: "hidden", p: 0.35 },
    emptyRowCell: { color: "text.secondary", py: 1.25 },
    footerRow: { bgcolor: "action.hover" },
    footerCell: { fontWeight: 700, borderTop: 2, borderColor: "divider", py: 0.75 },
  };
}

export interface ColumnFormatSelectComponentStyles {
  menuItemIndented: AppSx;
  menuPaper: AppSx;
  customPatternField: AppSx;
  currencyField: AppSx;
}

export function buildColumnFormatSelectComponentStyles(_theme: Theme): ColumnFormatSelectComponentStyles {
  return {
    menuItemIndented: { pl: 3 },
    menuPaper: { maxHeight: 360 },
    customPatternField: { ...TABLE_CELL_INPUT_SX, flex: "1 1 160px", minWidth: 0 },
    currencyField: { ...TABLE_CELL_INPUT_SX, width: 96, flex: "0 0 auto" },
  };
}
